import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'src/app/services/i18n.service';
import { SolStorageService } from 'src/app/services/sol-storage.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { SolApiService } from 'src/app/services/sol-api.service';
import { JsonFilesService } from 'src/app/services/jsonFiles.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SideMenuService } from '../side-menu/side-menu.service';
@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent implements OnInit {
  search = false;
  currentLang;
  isLoggedIn: boolean;
  token;
  userInfo;
  searchStructure = { key: '', title: '', title_en: '', url: '', description: '', description_en: '', fraud_id: '', fraud_category_id: '', expId: '', storyId: '', noId: false };
  searchKeys = [];
  searchValues = [];
  newSearchValues = [];
  innerWidth;
  menuItems = [];
  fraudMenu = [
    // { id: null, title: 'XXمعايير عامة للتعرف على النصب و الإحتيال', title_en: 'XXGeneral standards to identify fraud', routerLink: '/pages/fraud/GeneralStandards' },
    // { id: null, title: 'XXأنواع النصب و الإحتيال', title_en: 'XXTypes of Fraud', routerLink: '/pages/fraud' },
    // { id: null, title: 'XXهل وقعت ضحية نصب و إحتيال؟', title_en: 'XXHave you ever been trapped as a victim of fraud?', routerLink: '/pages/fraud/VictimToScam' }
  ];
  mediaMenu = [
    // { id: null, title: 'XXالأخبار', title_en: 'XXNews', routerLink: '/pages/mediacenter/news' },
    // { id: null, title: 'XXمكتبة الوسائط', title_en: 'XXMultimedia Library', routerLink: '/pages/mediacenter/mediagallery' },
    // { id: null, title: 'XXالفعاليات', title_en: 'XXEvents', routerLink: '/pages/mediacenter/events' },
    // { id: null, title: 'XXروابط هامة', title_en: 'XXImportant Links', routerLink: '/pages/mediacenter/importantlinks' },
    // { id: null, title: 'XXالأسئلة الشائعة', title_en: 'XXFAQs', routerLink: '/pages/mediacenter/faq' },
  ];
  experienceMenu = [
    // { id: null, title: 'XXتجارب المستهلكين', title_en: 'XXConsumers\' Experiences', routerLink: '/pages/ShareYourExperience/UsersExperience' },
    // { id: null, title: 'XXقصص واقعيه', title_en: 'XXReal Stories', routerLink: '/pages/ShareYourExperience/RealStories' },
    // { id: null, title: 'XXإضافة تجربة جديدة', title_en: 'XXAdd a new expereince', routerLink: '/pages/ShareYourExperience/AddExperience' }
  ];
  aboutMenu = [
    // { id: null, title: 'XXشروط الإستخدام', title_en: 'XXTerms Of Use', routerLink: '/pages/AboutTheProgram/TermsOfUse' },
    // { id: null, title: 'XXشروط الخصوصية', title_en: 'XXPrivacy Policy', routerLink: '/pages/AboutTheProgram/UsePolicy' },
    // { id: null, title: 'XXاتصل بنا', title_en: 'XXContact Us', routerLink: '/pages/AboutTheProgram/ContactUs' }
  ];
  @ViewChild(ModalDirective, { static: false }) modal: ModalDirective;
  constructor(private translate: TranslateService,
    private i18nService: I18nService,
    private router: Router,
    private sideMenuService: SideMenuService,
    private storageService: SolStorageService,
    private apiService: SolApiService,) {
    this.i18nService.getLang().subscribe((lng) => {
      if (lng == null) {
        lng = 'ar';
      }
      this.currentLang = lng;
    });
  }

  ngOnInit() {
    this.getNavigationMenu();
    this.innerWidth = window.innerWidth;
    if (this.currentLang == 'ar') {
      $('.engLang').css('margin-right', '1%')
    } else {
      $('.engLang').css('margin-right', '1%')
    }
    this.token = localStorage.getItem('SCAM-token');
    this.isLoggedIn = localStorage.getItem('SCAM-token') !== null ? true : false;
    if (this.isLoggedIn) {
      this.storageService.currentUserData.subscribe(user => {
        this.userInfo = user;
      })
      if (!this.userInfo) {
        this.initProfileData();
      }
    }
  }


  getNavigationMenu() {
    this.apiService
      .get(false, 'getMenu', {})
      .subscribe(response => {
        this.menuItems = response.data.pages;
        this.menuItems.reverse()
        this.menuItems.forEach(item => {
          switch (item.slug) {
            case 'fraud':
              item.pages = this.fraudMenu.concat(item.pages);
              // item.pages = item.pages;
              // item.pages.push({ id: null, title: 'قائمة المتاجر المخالفة', title_en: 'List of violating stores', routerLink: '/pages/fraud/violating-stores' })
              break;
            case 'mediacenter':
              item.pages = this.mediaMenu.concat(item.pages);
              // item.pages = item.pages;
              break;
            case 'ShareYourExperience':
              item.pages = this.experienceMenu.concat(item.pages);
              // item.pages = item.pages;
              break;
            case 'AboutTheProgram':
              item.pages = this.aboutMenu.concat(item.pages);
              // item.pages = item.pages;
              break;
            default:
              break;
          }
        })
        localStorage.setItem('menuItems', JSON.stringify(this.menuItems))

      });
  }
  initProfileData() {
    this.apiService
      .get(true, 'userProfile', `token=${this.token}`)
      .subscribe(response => {
        this.userInfo = response;
      });
  }
  navToSubMenu(parent, slug, id, old, page) {
    let data = { id: null, slug: slug }

    this.sideMenuService.setMenuItems(data, this.menuItems);

    if (page.routerLink) {
      this.router.navigateByUrl(page.routerLink);
    } else if (old) {
      this.router.navigateByUrl('pages/' + parent + (slug == '' ? '' : '/' + slug));
    } else if (page.external_url) {
      window.location.href = page.external_url;
    } else {
      // this.router.navigateByUrl(`pages/page/${slug}/${id}`)
      this.router.navigateByUrl(`pages/page/${parent}/${id}`)
    }
  }
  navigateToEnglish() {
    this.translate.use('en');
    localStorage.setItem('lng', 'en');
    this.i18nService.setLang('en');
    if (this.currentLang == 'ar') {
      $('.engLang').css('margin-right', '8%')
    } else {
      $('.engLang').css('margin-right', '1%')
    }
  }

  navigateToArabic() {
    this.translate.use('ar');
    localStorage.setItem('lng', 'ar');
    this.i18nService.setLang('ar');
    if (this.currentLang == 'ar') {
      $('.engLang').css('margin-right', '8%')
    } else {
      $('.engLang').css('margin-right', '1%')
    }
  }
  logout() {
    this.storageService.removeItem('token');
    this.storageService.removeItem('user');
    this.router.navigateByUrl('/auth/login');
  }

  onEnterSearch(word) {
    this.router.navigateByUrl(`/pages/search?word=${word.target.value}`)
    this.search = false;
  }

}
